import { skipToken, useQuery } from '@tanstack/react-query';
import type { PrepareNativeLabOrderSetRequestT } from '@lotushealth/lotushealth_js_sdk/schemas';

import {
  fetchPrepareNativeLabOrderSet,
  type PrepareNativeLabOrderSetResultT,
} from '../api/prepareNativeLabOrderSet.js';
import { labsKeys } from './keys.js';

export function usePrepareNativeLabOrderSetQuery(
  request: PrepareNativeLabOrderSetRequestT | undefined
) {
  return useQuery<PrepareNativeLabOrderSetResultT>({
    queryKey: request
      ? labsKeys.nativeOrderSetPreparation(request)
      : ['labs', 'native-order-set', 'prepare', 'disabled'],
    queryFn: request
      ? ({ signal }: { signal?: AbortSignal }) => fetchPrepareNativeLabOrderSet(request, signal)
      : skipToken,
  });
}
